import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 14172 16183"
    {...props}
  >
    <path
      d="m1202 12405 8314-9941H2373c-501 0-877-110-1130-332-256-222-380-512-380-874 0-373 124-678 380-911C1496 117 1872 0 2373 0h9207c1191 0 1786 558 1786 1669 0 531-98 953-298 1269-200 317-599 829-1202 1537l-7771 9245h8566c505 0 886 105 1134 316 253 207 377 501 377 878 0 388-124 697-377 927-248 230-629 342-1134 342H2151c-712 0-1250-162-1608-482-362-320-543-746-543-1284 0-185 30-354 87-509 60-154 139-301 237-437 102-135 237-309 414-516 178-211 332-395 464-550z"
      style={{
        fill: "#2b2a29",
        fillRule: "nonzero",
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
